import { useNavigate } from 'react-router-dom';
import { useAuth } from '../Routes/AuthContext';

/**
 * Custom hook to handle navigation with authentication checks
 * If user is not authenticated, redirects to login page
 */
export const useAuthNavigation = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const navigateWithAuth = (path) => {
    if (isAuthenticated) {
      navigate(path);
    } else {
      // Store the intended destination to redirect after login
      localStorage.setItem('redirectAfterLogin', path);
      navigate('/login');
    }
  };

  return { navigateWithAuth, isAuthenticated };
};
